"use strict";import{tag as a}from"../custom-tag.js";export function questionFilledIcon({height:e=16,width:l=16,hidden:t=!1,title:i="Question filled"}={}){return a`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width=${l}
      height=${e}
      fill="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="${t?"true":"false"}"
      role="img"
      aria-label="${i}"
    >
      <mask
        id="question-filled_svg__mask0_3955_333"
        width="20"
        height="20"
        x="2"
        y="2"
        maskUnits="userSpaceOnUse"
        style="mask-type:alpha"
      >
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M12.562 2.015a10 10 0 0 1 6.895 3.31 10.007 10.007 0 0 1-8.029 16.658 9.95 9.95 0 0 1-6.9-3.326 10.007 10.007 0 0 1 8.034-16.642M9.387 7.278a3.7 3.7 0 0 1 2.606-1.08 3.69 3.69 0 0 1 3.687 3.686c0 1.572-1.041 2.508-2.247 3.592l-.003.002-.012.011-.128.115c-.3.27-.612.554-.924.866l-.373.373-.745-.745.373-.373c.375-.375.75-.712 1.106-1.03l.11-.1c1.045-.94 1.79-1.645 1.79-2.71a2.634 2.634 0 0 0-5.267 0v.526H8.306v-.527a3.7 3.7 0 0 1 1.081-2.606m3.133 9.453h-1.054v1.054h1.054z"
          clip-rule="evenodd"
        />
      </mask>
      <g mask="url(#question-filled_svg__mask0_3955_333)">
        <path fill="currentColor" d="M24 0H0v24h24z" />
      </g>
    </svg>
  `}
//# sourceMappingURL=questionFilled.js.map
